var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHomeGetAText(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "100%",
    height: "100%",
    viewBox: "0 0 460 368",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(1.5 2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(177.987 59.903)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F7F7F7",
    stroke: "#181818",
    strokeWidth: 3,
    d: "M30 0h219c16.569 0 30 13.431 30 30v274h0H0V30C0 13.431 13.431 0 30 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#3B3A3A",
    strokeWidth: 2,
    d: "M34 9h25.313v11.244c0 6.627 5.372 12 12 12h129.88c6.551 0 11.892-5.255 11.998-11.806L213.376 9H245c13.255 0 24 10.745 24 24v268.029h0H10V33C10 19.745 20.745 9 34 9z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 174,
    height: 24,
    x: 52.5,
    y: 193.097,
    fill: "#ECECEC",
    rx: 12
  }), /*#__PURE__*/React.createElement("rect", {
    width: 64.5,
    height: 7,
    x: 96,
    y: 14.244,
    fill: "#ECECEC",
    rx: 3.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 172.244,
    cy: 17.744,
    r: 5.744,
    fill: "#ECECEC"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 167.308,
    height: 100,
    x: 233.833,
    y: 129.066,
    fill: "#ECECEC",
    rx: 10
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#5B5B5B",
    fontFamily: "Lato-Regular, Lato",
    fontSize: 64
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 298.487,
    y: 203.403
  }, "$")), /*#__PURE__*/React.createElement("path", {
    fill: "#F7F7F7",
    stroke: "#181818",
    strokeWidth: 3,
    d: "M30 0h219c16.569 0 30 13.431 30 30v334h0H0V30C0 13.431 13.431 0 30 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#3B3A3A",
    strokeWidth: 2,
    d: "M34 9.202h25.313v11.766c0 6.628 5.372 12 12 12h129.875c6.554 0 11.895-5.257 11.999-11.81l.189-11.956H245c13.255 0 24 10.745 24 24V364h0H10V33.202c0-13.255 10.745-24 24-24z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#EA6C55",
    d: "M183.306 0c8.836 0 16 7.163 16 16v44c0 8.837-7.164 16-16 16h-161c-3.025 0-5.853-.84-8.265-2.297C8.46 75.724 3.957 76.443.526 75.86c-2.767-1.253 6.284-5.92 6.29-11.59l.088.079c-.39-1.383-.598-2.842-.598-4.349V16c0-8.837 7.163-16 16-16h161z",
    transform: "translate(23 58.903)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#FFF",
    fontFamily: "Lato-Medium, Lato",
    fontSize: 16,
    fontWeight: 400,
    transform: "translate(23 58.903)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 22.306,
    y: 24
  }, "Do you have extra "), /*#__PURE__*/React.createElement("tspan", {
    x: 22.306,
    y: 43
  }, "expenses or losses due "), /*#__PURE__*/React.createElement("tspan", {
    x: 22.306,
    y: 62
  }, "to the earthquake?"))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#ECECEC",
    d: "M15.75 0C7.052 0 0 7.052 0 15.75S7.052 31.5 15.75 31.5h26.5c2.974 0 5.756-.825 8.13-2.257 5.526 1.991 9.992 2.697 13.4 2.117 2.767-1.253-6.284-5.92-6.29-11.59l-.01.01c.34-1.287.52-2.637.52-4.03C58 7.052 50.948 0 42.25 0h-26.5z",
    transform: "translate(190.5 164.403)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#3D3D3D",
    fontFamily: "Lato-Medium, Lato",
    fontSize: 16,
    fontWeight: 400,
    transform: "translate(190.5 164.403)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 14.306,
    y: 21.778
  }, "Yes!"))), /*#__PURE__*/React.createElement("rect", {
    width: 64.5,
    height: 7,
    x: 96,
    y: 14.244,
    fill: "#ECECEC",
    rx: 3.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 172.244,
    cy: 17.744,
    r: 5.744,
    fill: "#ECECEC"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeGetAText);
export default __webpack_public_path__ + "static/media/home-get-a-text.13292aed492d5c2c8e05af495ef98066.svg";
export { ForwardRef as ReactComponent };